export default "__VITE_ASSET__B8e5T_Xj__"